import axios from 'axios';
import {API} from 'js/constants';


/**
 * send mail
 * @param {object} params
 * @return {object}
 */
export function send(params = {}) {
  const result = {
    error: true,
  };

  return axios
    .post(API.mail, params)
    .then((response) => {
      const {
        data,
      } = response || {};

      if (1 == data) {
        result.error = false;
      }

      return result;
    })
    .catch((error) => {
      return result;
    });
}



// WEBPACK FOOTER //
// ./src/js/utils/api/mail.js